export class UndoRedoHistory<T> {
  private undoStack: T[] = [];
  private redoStack: T[] = [];

  constructor(
    private readonly serialize: (snapshot: T) => string,
    private readonly maxEntries = 100
  ) {}

  get canUndo(): boolean {
    return this.undoStack.length > 0;
  }

  get canRedo(): boolean {
    return this.redoStack.length > 0;
  }

  clear(): void {
    this.undoStack = [];
    this.redoStack = [];
  }

  capture(snapshot: T): void {
    const nextSnapshot = structuredClone(snapshot);
    const nextHash = this.serialize(nextSnapshot);
    const lastSnapshot = this.undoStack[this.undoStack.length - 1];

    if (lastSnapshot && this.serialize(lastSnapshot) === nextHash) {
      return;
    }

    this.undoStack.push(nextSnapshot);
    if (this.undoStack.length > this.maxEntries) {
      this.undoStack.shift();
    }

    this.redoStack = [];
  }

  undo(currentSnapshot: T): T | null {
    if (!this.undoStack.length) {
      return null;
    }

    this.redoStack.push(structuredClone(currentSnapshot));
    return structuredClone(this.undoStack.pop() as T);
  }

  redo(currentSnapshot: T): T | null {
    if (!this.redoStack.length) {
      return null;
    }

    this.undoStack.push(structuredClone(currentSnapshot));
    return structuredClone(this.redoStack.pop() as T);
  }
}
